<template>
    <ul class="tree">
        <ArticleTreeItem
            :root="true"
            :root-article="article"
            :article="article"
            :readonly="readonly"
            :identifiers-translations="attributes.ProductId"
            :names-translations="attributes.ProductName"
            @change="$emit('change')"
        />
    </ul>
</template>

<script>
import ArticleTreeItem from "@/views/product/components/scip-notification/ArticleTreeItem.vue";
import {ProductApi} from "@core/api";
import {ProductProvider} from "@core/domain/product";
export default {
    components: {
        ArticleTreeItem
    },
    props: {
        readonly: {
            default: false
        },
        article: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            attributes: {
                ProductId: {},
                ProductName: {}
            }
        };
    },
    created() {
        ProductApi.getAttributes().then(r => {
            r.data.ProductId.forEach(({key, title}) => {
                this.attributes.ProductId[key] = title;
            });
            r.data.ProductName.forEach(({key, title}) => {
                this.attributes.ProductName[key] = title;
            });
        });
    }
}
</script>

<style scoped lang="scss">
ul.tree, ul.tree ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
</style>
